import { Theme } from '@material-ui/core';

export const MuiIconButton = (theme: Theme): Record<string, unknown> => ({
  sizeSmall: {
    '& .MuiSvgIcon-root': {
      fontSize: '1.125rem',
    },
  },
});
